"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterDropdownActions = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
/**
 * This component displays two buttons Apply and Cancel.
 * Apply button is disabled when selection is not changed.
 * Cancel button discard changes and close AttributeFilter dropdown.
 *
 * @beta
 */
exports.AttributeFilterDropdownActions = function (_a) {
    var isApplyDisabled = _a.isApplyDisabled, onApplyButtonClick = _a.onApplyButtonClick, onCancelButtonClick = _a.onCancelButtonClick;
    var intl = react_intl_1.useIntl();
    var cancelText = intl.formatMessage({ id: "gs.list.cancel" });
    var applyText = intl.formatMessage({ id: "gs.list.apply" });
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-dropdown-actions__next" },
        react_1.default.createElement("div", { className: "gd-attribute-filter-dropdown-actions-left-content__next" }),
        react_1.default.createElement("div", { className: "gd-attribute-filter-dropdown-actions-right-content__next" },
            react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-attribute-filter-cancel-button__next gd-button-secondary gd-button-small cancel-button s-cancel", onClick: onCancelButtonClick, value: cancelText, title: cancelText }),
            react_1.default.createElement(sdk_ui_kit_1.Button, { disabled: isApplyDisabled, className: "gd-attribute-filter-apply-button__next gd-button-action gd-button-small s-apply", onClick: onApplyButtonClick, value: applyText, title: applyText }))));
};
//# sourceMappingURL=AttributeFilterDropdownActions.js.map